<template>
    <main>
        <!-- breadcrumb-area-start -->
        <div class="it-breadcrumb-area it-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/breadcrumb/breadcrumb.png)' }">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="it-breadcrumb-content z-index-3 text-center">
                            <div class="it-breadcrumb-title-box">
                                <h3 class="it-breadcrumb-title">Admission</h3>
                            </div>
                            <div class="it-breadcrumb-list-wrap">
                                <div class="it-breadcrumb-list">
                                    <span><a href="#">home</a></span>
                                    <span class="dvdr">//</span>
                                    <span>Admission</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- breadcrumb-area-end -->

        <div class="it-sv-details-area pt-120 pb-120">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12 col-lg-12">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="it-sv-details-top-content mb-50">
                                    <h4 class="it-sv-details-title">ADMISSION PROCESS</h4>
                                    <ul>
                                        <li>Entrance Exams (CAT/CET/ATMA/CMAT) is a must.</li>
                                        <li>The admission process is through Centralized Admission Process (CAP) organised by D.T.E., Maharashtra.</li>
                                        <li>Candidates are required to report to the institute before the respective CAP round end along with the required documents and fees to the allotted institute.</li>
                                        <li>After successful verification and payment process, the admission of the candidate is confirmed.</li>
                                    </ul>                                        
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
export default {
    name: "AdmissionView"
};
</script>
